import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=165837f2&"
import script from "./Accordion.ts?vue&type=script&lang=ts&"
export * from "./Accordion.ts?vue&type=script&lang=ts&"
import style0 from "./Accordion.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports